<template>
	<div class="gd_card_tmp-container">
		<el-dialog :visible.sync="isShowDialog" title="资产模板导入" width="500px" draggable="">
			<el-main>
				<div class="import-content">
					<!-- 普通格式选择 -->
					<div class="format-section">
						<label class="format-label">普通格式</label>
						<el-select v-model="selectedFormat" placeholder="请选择格式" class="format-select">
							<el-option label="Excel格式" value="excel"></el-option>
						</el-select>
					</div>

					<!-- 文件选择区域 -->
					<div class="file-section">
						<div class="file-input-wrapper">
							<span class="file-label">请选择EXCEL格式文件</span>
							<el-upload ref="uploadRef" class="file-upload" :headers="uploadHeaders"
								:show-file-list="false" :action="baseUrl" :on-success="handleSuccess"
								:on-error="handleError" :before-upload="before_upload" accept=".xlsx,.xls" :limit="1"
								:auto-upload="false" :on-change="handleFileChange">
								<el-button type="primary" class="upload-btn">上传</el-button>
							</el-upload>
						</div>
						<div class="file-name" v-if="selectedFileName">{{ selectedFileName }}</div>
					</div>

					<!-- 导入规则说明 -->
					<div class="rules-section">
						<div class="rules-title">导入规则说明:</div>
						<div class="rules-content">
							<p>1.文件后缀名必须为: xls或xlsx（Excel标准格式），文件大小限制5MB。</p>
							<p>2.请勿移动，表头位置，否则可能导致导入失败。</p>
						</div>
					</div>

					<!-- 下载模板链接 -->
					<div class="template-section">
						<a class="template-link" href="#" @click="downloadFiless">下载模板</a>
					</div>
				</div>
			</el-main>
			<template slot="footer">
				<span class="dialog-footer">
					<el-button @click="closeDialog" size="default">关闭</el-button>
					<el-button type="primary" @click="submitUpload" :loading="loading"
						:disabled="!selectedFile || !fileReady" size="default">确定导入</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
import store from '../../store'
import { getToken } from '@/utils/auth'
export default {
	props: {
		FileName: {
			type: String, // 定义传递参数的类型
		},
		url: {
			type: String, // 定义传递参数的类型
		}
	},
	data() {
		return {
			loading: false,
			isShowDialog: false,
			selectedFormat: 'excel',
			selectedFileName: '',
			selectedFile: null,
			uploadHeaders: {},
			fileReady: false
		};
	},
	computed: {
		baseUrl() {
			return `${process.env.VUE_APP_BASE_API}` + (this.url || '');
		}
	},
	watch: {
		isShowDialog(newVal) {
			if (!newVal) {
				// 当对话框关闭时，确保清理文件上传状态
				this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
				this.selectedFileName = '';
				this.selectedFile = null;
				this.fileReady = false;
			}
		}
	},
	methods: {
		downloadFiless() {
			try {
				const baseUrl = process.env.VUE_APP_BASE_API;
				const address = baseUrl.match(/^https?:\/\/[^/]+/)?.[0] || baseUrl;
				const fileUrl = `${address}/downloadFile/${encodeURIComponent(this.FileName)}`;
				window.open(`${baseUrl}/commonInterfaces/downloadFile?fileUrl=${encodeURIComponent(fileUrl)}`, '_blank');
			} catch (error) {
				console.error('下载模板出错:', error);
				this.$message.error('下载模板失败，请稍后重试');
			}
		},
		openDialog() {
			this.isShowDialog = true;
			this.fileReady = false;
		},
		closeDialog() {
			this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
			this.selectedFileName = '';
			this.selectedFile = null;
			this.fileReady = false;
			this.$emit("reloadTable");
			this.isShowDialog = false;
		},
		handleFileChange(file) {
			this.selectedFile = file;
			this.selectedFileName = file.name;
			// 添加延迟确保文件名已更新到界面
			setTimeout(() => {
				this.fileReady = true;
			}, 500);
		},
		submitUpload() {
			if (!this.selectedFile) {
				this.$message.warning('请先选择要上传的文件');
				return;
			}

			if (!this.fileReady) {
				this.$message.warning('文件正在准备中，请稍候再试');
				return;
			}

			this.loading = true;
			this.$refs.uploadRef.submit();
		},
		handleProgress() {
			this.loading = true;
		},
		before_upload(file) {
			// 重置文件准备状态
			this.fileReady = false;

			let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (fileType == 'xls' || fileType == 'xlsx') {
				// 检查文件大小（5MB = 5 * 1024 * 1024 bytes）
				if (file.size > 5 * 1024 * 1024) {
					this.$message.error("文件大小不能超过5MB");
					this.loading = false;
					return false;
				}

				// 在上传之前设置自定义的请求头
				this.uploadHeaders.tenantId = store.getters.tenantid
				if (store.getters.token) {
					this.uploadHeaders['X-Token'] = getToken()
				}

				if (store.getters.isIdentityAuth) {
					this.uploadHeaders['Authorization'] = 'Bearer ' + store.getters.oidcAccessToken
				}
				return true;
			} else {
				this.$message.error("文件类型必须为excel格式");
				this.loading = false;
				return false;
			}
		},
		handleSuccess(response) {
			this.loading = false;
			if (response.code == 200) {
				this.$emit("reloadTable");
				this.isShowDialog = false;
				this.$message.success(response.message);
			} else {
				this.$message.error(response.message);
			}
			this.$refs.uploadRef.clearFiles();
			this.selectedFileName = '';
			this.selectedFile = null;
			this.fileReady = false;
		},
		handleError(error) {
			this.loading = false;
			this.$emit("reloadTable");
			this.$message.error(error.message);
			this.$refs.uploadRef.clearFiles();
			this.selectedFileName = '';
			this.selectedFile = null;
			this.fileReady = false;
		}
	}
};
</script>

<style scoped>
.import-content {
	padding: 10px 0;
}

.format-section {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}

.format-label {
	width: 80px;
	font-size: 14px;
	color: #333;
}

.format-select {
	width: 200px;
}

.file-section {
	margin-bottom: 20px;
}

.file-input-wrapper {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.file-label {
	margin-right: 10px;
	font-size: 14px;
	color: #333;
}

.file-upload {
	display: inline-block;
}

.upload-btn {
	background-color: #409EFF;
	border-color: #409EFF;
	padding: 8px 20px;
	font-size: 14px;
}

.file-name {
	font-size: 12px;
	color: #666;
	margin-left: 10px;
	padding: 5px 0;
}

.rules-section {
	background-color: #f5f7fa;
	padding: 15px;
	border-radius: 4px;
	margin-bottom: 20px;
}

.rules-title {
	font-size: 14px;
	font-weight: bold;
	color: #333;
	margin-bottom: 10px;
}

.rules-content p {
	margin: 5px 0;
	font-size: 13px;
	color: #666;
	line-height: 1.5;
}

.template-section {
	text-align: left;
}

.template-link {
	color: #409EFF;
	text-decoration: none;
	font-size: 14px;
}

.template-link:hover {
	color: #66b1ff;
	text-decoration: underline;
}

.dialog-footer {
	text-align: right;
}

.dialog-footer .el-button {
	margin-left: 10px;
}
</style>